import { stringify } from 'query-string';
import { getGlobalData, setGlobalData } from "../lib/globalData"

class DataProvider {
  init (apiUrl, setToken) {
    this.apiUrl = apiUrl;
    const token = getGlobalData('token');
    if (token) {
      setToken(token);
    }
    else {
      setGlobalData({token:'-'});
      const url = `${this.apiUrl}/token`;
      fetch("https://"+url, {method: 'POST', body:'{"username":"anonymous"}'})
      .then((res) => res.json())
      .then((data) => {
        setGlobalData({token:data.token});
        localStorage.setItem('token', data.token);
        setToken(data.token);
        document.cookie = 'token='+data.token;
      })
    }
    return false;
  }
  
  getList(resource, params, callback) {
    const token = getGlobalData('token');
    if (!token) return false;
    
    const query = {
        sort: params.sort?JSON.stringify(params.sort):[],
        filter: params.filter?JSON.stringify(params.filter):[],
    };
    if (params.sorting) {
      query.sorting = params.sorting;
    }
    const url = `${this.apiUrl}/${resource}?${stringify(query)}`;
    
    const headers = {
      'Content-Type': 'application/json',
      'authorization': token,
    };

    fetch("https://"+url, {headers:headers})
    .then((res) => res.json())
    .then((data) => {
      callback(data);
    })
  }

  getRow(resource, id, param, callback) {
    const token = getGlobalData('token');
    if (!token) return false;
    
    var url = `${this.apiUrl}/${resource}/${id}`;
    if (param) {
      url += '?'+param;
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'authorization': token,
    };

    fetch("https://"+url, {headers:headers})
    .then((res) => res.json())
    .then((data) => {
      callback(data);
    })
  }

  update(resource, params, callback) {
    const token = getGlobalData('token');
    const headers = {
      'Content-Type': 'application/json',
      'authorization': token,
    };

    const request = new Request('https://' + this.apiUrl + '/' + resource, {
      method: 'PUT',
      body: JSON.stringify(params),
      headers: new Headers(headers),
    });

    const p = fetch(request)
      .then((response) => response.json())
      .then((data) => {
        if (data.error && data.message) {
          alert(data.message);
          throw new Error(data.message);
        }
        if (callback) {
          callback(data);
        }
        return data;
      });

    return p;
  }

  upload(resource, id, audioblob, callback, errorcallback) {
    const token = getGlobalData('token');
    const headers = {
      'authorization': token,
    };
    const request = new Request('https://'+this.apiUrl+'/'+resource+'/'+id, {
        method: 'POST',
        body: audioblob,
        headers: new Headers(headers),
    })
    fetch(request)
    .then(async (response) => {
      const text = await response.text();
      const data = text ? JSON.parse(text) : {};
      if (data.error || response.status !== 200) {
        if (data.error && data.message) {
          alert(data.message);
        }
        if (errorcallback) {
          errorcallback(data);
        }
        return false;
      }
      if (callback) {
        callback(data);
      }
    });
  }
  
  insert(resource, params, callback) {
    const token = getGlobalData('token');
    const headers = {
      'Content-Type': 'application/json',
      'authorization': token,
    };
    const request = new Request('https://'+this.apiUrl+'/'+resource, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: new Headers(headers),
    })
    fetch(request)
    .then(response => {
      if (response.status < 200 || response.status >= 300) {
        alert(response.statusText);
        return false;
      }
      return response.json();
    })
    .then((data) => {
      if (callback) {
        callback(data);
      }
    });
  }
  
  del(resource, params, callback) {
    const token = getGlobalData('token');
    const headers = {
      'Content-Type': 'application/json',
      'authorization': token,
    };
    const request = new Request('https://'+this.apiUrl+'/'+resource, {
        method: 'DELETE',
        body: JSON.stringify(params),
        headers: new Headers(headers),
    })
    fetch(request)
    .then(response => {
      if (response.status < 200 || response.status >= 300) {
        alert(response.statusText);
        return false;
      }
      return response.json();
    })
    .then((data) => {
      if (callback) {
        callback(data);
      }
    });
  }
  
  download(resource) {
    const token = getGlobalData('token');
    const headers = {
      'Content-Type': 'application/octet-stream',
      'authorization': token,
    };
    const request = new Request('https://'+this.apiUrl+'/'+resource, {
        method: 'GET',
        headers: new Headers(headers),
    })
    fetch(request)
    .then((response) => response.blob())
    .then((blob) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(
        new Blob([blob]),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `test.gme`,
      );

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    });
  }
}




export default DataProvider
